var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2900 1900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#fefffe",
    d: "M 2053.5,857.5 C 2138.83,857.333 2224.17,857.5 2309.5,858C 2321.87,861.709 2328.2,870.042 2328.5,883C 2328.68,887.37 2327.84,891.536 2326,895.5C 2080.67,1209.5 1835.33,1523.5 1590,1837.5C 1572.2,1856.57 1552.37,1859.07 1530.5,1845C 1329.95,1590.12 1129.79,1334.95 930,1079.5C 923.182,1066.92 924.682,1055.42 934.5,1045C 937.554,1042.81 940.888,1041.14 944.5,1040C 1030.17,1039.33 1115.83,1039.33 1201.5,1040C 1212.91,1042.28 1222.41,1047.78 1230,1056.5C 1329,1180.83 1428,1305.17 1527,1429.5C 1548.65,1449.98 1569.65,1449.31 1590,1427.5C 1734.33,1243.5 1878.67,1059.5 2023,875.5C 2031.2,865.992 2041.36,859.992 2053.5,857.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fefffe",
    d: "M 408.5,1038.5 C 492.167,1038.33 575.834,1038.5 659.5,1039C 675.458,1041.39 687.958,1049.23 697,1062.5C 850.188,1261.36 1004.52,1459.36 1160,1656.5C 1166.26,1671.65 1165.92,1686.65 1159,1701.5C 1124.67,1745.17 1090.33,1788.83 1056,1832.5C 1038.49,1855.91 1017.33,1860.08 992.5,1845C 792.285,1590.45 592.452,1335.62 393,1080.5C 384.724,1066.54 386.558,1054.04 398.5,1043C 401.815,1041.17 405.149,1039.67 408.5,1038.5 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcIcon);
export default __webpack_public_path__ + "static/media/wc-icon.b361d254.svg";
export { ForwardRef as ReactComponent };